import NotificationItemComponent from './notification-item.component'

const NotificationItemModule = angular.module('cdbl.notifications.notification-item', [

])
  .component('cdblNotificationItem', NotificationItemComponent)
  .name

export default NotificationItemModule
